// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__o7ZSG","delete":"styles_delete__1UP4d","update":"styles_update__3nI6y","add":"styles_add__1KxZX"};